module.exports = __webpack_public_path__ + "img/详情.afcf9386.svg";